
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/take-quiz/jst/LDBLoginPopup';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<form id=\"ldb_deauthorized_dialog\" class=\"hide\">\n  <div id=\"unauthorized_message\" class=\"ui-state-error\">\n    <h2 class=\"\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.titles.log_in", "Please Log In", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.titles.log_in", "Please Log In", options)))
    + "</h2>\n    <p>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<strong>$1</strong>"),
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.logged_out_of_canvas", "*You have been logged out of canvas.* To continue please log in.", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.logged_out_of_canvas", "*You have been logged out of canvas.* To continue please log in.", options)))
    + "\n    </p>\n  </div>\n\n  <h1>Canvas</h1>\n\n  <div>\n    <span class=\"field\">\n      <label for=\"pseudonym_session_unique_id\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.email", "Email", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.email", "Email", options)))
    + "</label>\n      <input id=\"pseudonym_session_unique_id\" type=\"text\" name=\"pseudonym_session[unique_id]\" class=\"text\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.email", "Email", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.email", "Email", options)))
    + "\" autocomplete=\"off\" />\n    </span>\n\n    <span class=\"field\">\n      <label for=\"pseudonym_session_password\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.password", "Password", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.password", "Password", options)))
    + "</label>\n      <input id=\"pseudonym_session_password\" type=\"password\" name=\"pseudonym_session[password]\" class=\"text\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.password", "Password", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.password", "Password", options)))
    + "\" autocomplete=\"off\" />\n    </span>\n  </div>\n\n  <div class=\"dialog-actions\">\n    <span class=\"btn btn-primary\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.ldb_login_popup")
  },data:data},helper ? helper.call(depth0, "quizzes.ldb_login_popup.log_in", "Log In", options) : helperMissing.call(depth0, "t", "quizzes.ldb_login_popup.log_in", "Log In", options)))
    + "</span>\n  </div>\n</form>";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '9c',
      bundle: 'jst/quizzes/LDBLoginPopup'
    });
  ;
    export default templates[name];
  